import { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert, Row, Col } from 'react-bootstrap';
import { FaPaperPlane, FaSpinner } from 'react-icons/fa';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import faqAreasService from '../../api/faq/faqAreasService';
import programaFaqService from '../../api/faq/programaFaqService';

const RegistrarDuvidaModal = ({ show, onHide, programaId }) => {
    const [pergunta, setPergunta] = useState('');
    const [contexto, setContexto] = useState('');
    const [selectedArea, setSelectedArea] = useState('');
    const [areas, setAreas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (show) {
            carregarAreas();
        }
    }, [show]);

    const carregarAreas = async () => {
        try {
            const response = await faqAreasService.getAll({ ativo: true });
            setAreas(response.data.results || []);
        } catch (err) {
            console.error("Erro ao carregar áreas:", err);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!programaId) {
            setError('Erro: Nenhum programa selecionado.');
            return;
        }

        if (!selectedArea) {
            setError('Por favor, selecione uma área.');
            return;
        }

        if (!pergunta.trim()) {
            setError('Por favor, digite sua dúvida.');
            return;
        }

        if (!contexto.trim()) {
             setError('Por favor, informe o contexto da dúvida.');
             return;
        }

        setLoading(true);
        setError('');

        try {
            const payload = {
                programa_id: programaId,
                pergunta: pergunta,
                area_id: selectedArea,
                contexto: contexto
            };

            const response = await programaFaqService.registrarDuvida(payload);

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                title: <p>Dúvida enviada com sucesso!</p>,
                html: <p>{response.data.mensagem || 'Sua dúvida foi encaminhada para nossa equipe.'}</p>,
                icon: 'success',
                confirmButtonColor: '#28a745',
            });

            setPergunta('');
            setContexto('');
            setSelectedArea('');
            onHide();

        } catch (err) {
            console.error(err);
            let errorMsg = 'Ocorreu um erro ao enviar sua dúvida. Tente novamente.';
            
            if (err.response && err.response.data && err.response.data.erro) {
                errorMsg = err.response.data.erro;
            }

            setError(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setPergunta('');
        setContexto('');
        setSelectedArea('');
        setError('');
        setLoading(false);
        onHide();
    }

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Não encontrou o que procurava?</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <p className="text-muted mb-3">
                        Envie sua dúvida para nós! Nossa equipe analisará e responderá o mais breve possível.
                    </p>

                    {error && <Alert variant="danger">{error}</Alert>}
                    
                    <Row>
                        <Col sm={6}>
                             <Form.Group className="mb-3">
                                <Form.Label>Área <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    as="select"
                                    value={selectedArea}
                                    onChange={(e) => setSelectedArea(e.target.value)}
                                    disabled={loading}
                                    required
                                >
                                    <option value="">Selecione uma área</option>
                                    {areas.map(area => (
                                        <option key={area.id} value={area.id}>{area.nome}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                             <Form.Group className="mb-3">
                                <Form.Label>Contexto <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Ex: Tela de adesão"
                                    value={contexto}
                                    onChange={(e) => setContexto(e.target.value)}
                                    disabled={loading}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Form.Group className="mb-3">
                        <Form.Label>Sua dúvida <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            placeholder="Descreva sua dúvida aqui..."
                            value={pergunta}
                            onChange={(e) => setPergunta(e.target.value)}
                            disabled={loading}
                            required
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant="light" onClick={handleClose} disabled={loading}>
                        Cancelar
                    </Button>
                    <Button size="sm" variant="primary" type="submit" disabled={loading}>
                        {loading ? (
                            <>
                                <FaSpinner className="spinner-rotate me-1" /> Enviando...
                            </>
                        ) : (
                            <>
                                <FaPaperPlane className="me-1" /> Enviar Dúvida
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default RegistrarDuvidaModal;
